/**
 * Admin Base URL Configuration
 * Returns the admin base URL from environment variable
 * 
 * Usage in .env files:
 * - .env.staging: REACT_APP_ADMIN_BASE_URL=https://mabel.admin.stage.byod.ai
 * - .env.production: REACT_APP_ADMIN_BASE_URL=https://mabel.admin.prod.byod.ai
 */
export const getAdminBaseUrl = (): string => {
	return process.env.REACT_APP_ADMIN_BASE_URL || 'https://mabel.admin.stage.byod.ai';
};

